import { submit, submitUpdate, dadataAddressCalibration } from 'api'
import Actions from 'constants/Actions'
import Dispatcher from 'core/Dispatcher'
import history from 'core/history'
import transformGoogleGeocodedData from "../../tools/transform-google-geocoded-data";
import { find } from "lodash";
import { getLocationFromGoogleByQuery } from 'api';

const countriesConfig = require('../../configs/countries.config.json');

const ActionCreators = {

    saveState() {
        Dispatcher.dispatch({
            type: Actions.SAVE_STATE,
        });
    },

    loadState() {
        Dispatcher.dispatch({
            type: Actions.LOAD_STATE,
        });
    },

    selectCategory(categoryId) {
        Dispatcher.dispatch({
            type: Actions.SELECT_CATEGORY,
            payload: { categoryId },
        });
    },

    deselectCategory(query = {}) {
        Dispatcher.dispatch({
            type: Actions.DESELECT_CATEGORY,
        })
    },

    startCargoEditing(cargo, cargoId, isSecondEditing) {
        Dispatcher.dispatch({
            type: Actions.START_CARGO_EDITING,
            payload: { cargo, cargoId, isSecondEditing },
        });
    },

    stopCargoEditing() {
        Dispatcher.dispatch({
            type: Actions.STOP_CARGO_EDITING,
        });
    },

    cancelCargoEditing() {
        Dispatcher.dispatch({
            type: Actions.CANCEL_CARGO_EDITING,
        });
    },

    updateEditingCargo(payload) {
        Dispatcher.dispatch({
            type: Actions.UPDATE_EDITING_CARGO,
            payload,
        });
    },

    updateEditingCargoId(newCargoId) {
        Dispatcher.dispatch({
            type: Actions.UPDATE_EDITING_CARGO_ID,
            payload: { newCargoId },
        });
    },

    updateParameter(payload) {
        Dispatcher.dispatch({
            type: Actions.UPDATE_PARAMETER,
            payload,
        });
    },

    updateParameterPrice(payload) {
        Dispatcher.dispatch({
            type: Actions.UPDATE_PARAMETER_PRICE,
            payload,
        });
    },

    addCargo(cargo) {
        Dispatcher.dispatch({
            type: Actions.ADD_CARGO,
            payload: { cargo },
        });
    },

    generateCargo(cargo, attributes, clearDelivery) {
        Dispatcher.dispatch({
            type: Actions.GENERATE_CARGO,
            payload: { cargo, attributes, clearDelivery },
        });
    },

    removeCargo(cargoId) {
        Dispatcher.dispatch({
            type: Actions.REMOVE_CARGO,
            payload: { cargoId },
        });
    },

    /**
     * Добавление товара в список доставки
     * @param {CargoType} cargoType
     */
    addCargoToDelivery(cargoType) {
        Dispatcher.dispatch({
            type: Actions.ADD_DELIVERY_CARGO,
            payload: { cargoType },
        });
    },

    /**
     * Удаление товара из список доставки
     * @param {number} cargoId
     */
    removeCargoFromDelivery(cargoId) {
        Dispatcher.dispatch({
            type: Actions.REMOVE_DELIVERY_CARGO,
            payload: { cargoId },
        });
    },

    updateDeliveryCargo(payload) {
        Dispatcher.dispatch({
            type: Actions.UPDATE_DELIVERY_CARGO,
            payload,
        });
    },

    addSubcategory() {
        Dispatcher.dispatch({
            type: Actions.ADD_SUBCATEGORY,
        });
    },

    cargoComplete(categoryId, query = {}) {
        history.push({
            pathname: `/category/${categoryId}/route`,
            query: query,
            state: null,
        });
    },

    setStage(stage, query = {}) {
        history.push({
            pathname: stage,
            query: query,
            state: null,
        });
    },

    updateUser(payload) {
        Dispatcher.dispatch({
            type: Actions.UPDATE_USER,
            payload,
        });
    },

    updateShowTips(payload) {
        Dispatcher.dispatch({
            type: Actions.UPDATE_SHOWTIPS,
            payload,
        });
    },

    updateLocations(payload) {
        Dispatcher.dispatch({
            type: Actions.UPDATE_LOCATIONS,
            payload,
        });
    },

    updateDates(payload) {
        Dispatcher.dispatch({
            type: Actions.UPDATE_DATES,
            payload,
        });
    },

    updateTime(payload) {
        Dispatcher.dispatch({
            type: Actions.UPDATE_TIME,
            payload,
        });
    },

    submit() {
        return submit().then(
            response => response,
            error => console.log(error),
        )
    },

    submitUpdate() {
        return submitUpdate().then(
            response => {

                if (!response.redirect_url) {
                    if (response.request && typeof response.request === 'string') {
                        throw response.request;
                    } else {
                        throw false;
                    }
                }

                // In widget mode
                if (window.parent) {
                    window.parent.location.href = response.redirect_url
                } else {
                    window.location.href = response.redirect_url;
                }
            },
        );
    },

    setAttributeError(payload) {
        Dispatcher.dispatch({
            type: Actions.SET_ATTRIBUTE_ERROR,
            payload,
        });
    },

    setLocationsError(payload) {
        Dispatcher.dispatch({
            type: Actions.SET_LOCATION_ERROR,
            payload,
        });
    },

    setUserError(payload) {
        Dispatcher.dispatch({
            type: Actions.SET_USER_ERROR,
            payload,
        });
    },

    showLoadingOverlay() {
        Dispatcher.dispatch({
            type: Actions.SHOW_LOADING_OVERLAY,
        });
    },

    hideLoadingOverlay() {
        Dispatcher.dispatch({
            type: Actions.HIDE_LOADING_OVERLAY,
        });
    },

    validateCargo() {
        Dispatcher.dispatch({
            type: Actions.VALIDATE_CARGO,
        });
    },

    setValidToken(token) {
        Dispatcher.dispatch({
            type: Actions.SET_VALID_TOKEN,
            payload: { token },
        });
    },

    setAutologinHash(hash) {
        Dispatcher.dispatch({
            type: Actions.SET_AUTOLOGIN_HASH,
            payload: { hash },
        });
    },

    sendAttributesToGa() {
        Dispatcher.dispatch({
            type: Actions.SEND_ATTRIBUTES_TO_GA,
        });
    },

    sendParametersToGa() {
        Dispatcher.dispatch({
            type: Actions.SEND_PARAMETERS_TO_GA,
        });
    },

    sendRoutesToGa() {
        Dispatcher.dispatch({
            type: Actions.SEND_ROUTES_TO_GA,
        });
    },

    sendDatesToGa() {
        Dispatcher.dispatch({
            type: Actions.SEND_DATES_TO_GA,
        });
    },

    sendUserToGa() {
        Dispatcher.dispatch({
            type: Actions.SEND_USER_TO_GA,
        });
    },

    openWaypointMap(payload) {
        Dispatcher.dispatch({
            type: Actions.OPEN_WAYPOINT_YANDEX_MAP,
            payload,
        });
    },

    closeWaypointMap() {
        Dispatcher.dispatch({
            type: Actions.CLOSE_WAYPOINT_YANDEX_MAP,
        });
    },

    useWaypointMap(payload) {
        Dispatcher.dispatch({
            type: Actions.USE_WAYPOINT_YANDEX_MAP,
            payload,
        });
    },

    updateTmp(payload) {
        Dispatcher.dispatch({
            type: Actions.UPDATE_TMP,
            payload,
        });
    },

    setVVauthorizationStatus(payload) {
        Dispatcher.dispatch({
            type: Actions.SET_VV_AUTHORIZATION_STATUS,
            payload,
        });
    },

    denormalizeState(state) {
        Dispatcher.dispatch({
            type: Actions.DENORMALIZE_STATE,
            payload: { state },
        });
    },

    setMode(mode) {
        Dispatcher.dispatch({
            type: Actions.SET_MODE,
            payload: { mode },
        });
    },

    setOrderId(orderId) {
        Dispatcher.dispatch({
            type: Actions.SET_ORDER_ID,
            payload: { orderId },
        });
    },

    cancelTankmenValidation() {
        Dispatcher.dispatch({
            type: Actions.CANCEL_TANKMEN_VALIDATION,
        });
    },

    enableTankmenValidation() {
        Dispatcher.dispatch({
            type: Actions.ENABLE_TANKMEN_VALIDATION,
        });
    },

    setCarrierId(carrierId) {
        Dispatcher.dispatch({
            type: Actions.SET_CARRIER_ID,
            payload: { carrierId },
        });
    },

    setPereveziModeOn() {
        Dispatcher.dispatch({
            type: Actions.SET_PEREVEZI_MODE_ON,
        });
    },

    setB2B() {
        Dispatcher.dispatch({
            type: Actions.SET_B2B,
        });
    },

    setWidgetModeOn() {
        Dispatcher.dispatch({
            type: Actions.SET_WIDGET_MODE_ON,
        });
    },

    setClickId(clickId) {
        Dispatcher.dispatch({
            type: Actions.SET_CLICKID,
            payload: { clickId },
        });
    },

    setIsraelModeOn() {
        Dispatcher.dispatch({
            type: Actions.SET_ISRAEL_MODE_ON,
        });
    },

    setDefaultCountry(countryId) {
        Dispatcher.dispatch({
            type: Actions.SET_DEFAULT_COUNTRY,
            payload: { countryId },
        });
    },

    showApproximateUnitsWarning() {
        Dispatcher.dispatch({
            type: Actions.SHOW_APPROXIMATE_UNITS_WARNING,
        });
    },

    hideApproximateUnitsWarning() {
        Dispatcher.dispatch({
            type: Actions.HIDE_APPROXIMATE_UNITS_WARNING,
        });
    },

    changeTotalMeasurements(payload) {
        Dispatcher.dispatch({
            type: Actions.CHANGE_TOTAL_MEASUREMENTS,
            payload,
        });
    },

    setTotalMeasurements(weight, volume, isAutoTotalMeasurementsCountOn) {
        Dispatcher.dispatch({
            type: Actions.SET_TOTAL_MEASUREMENTS,
            payload: { weight, volume, isAutoTotalMeasurementsCountOn },
        });
    },

    setUserBalance(balance) {
        Dispatcher.dispatch({
            type: Actions.SET_USER_BALANCE,
            payload: { balance },
        })
    },

    setInstantBookingType(type) {
        Dispatcher.dispatch({
            type: Actions.SET_CALENDAR_TYPE,
            payload: { type },
        })
    },

    setInstantBookingPrices(prices) {
        Dispatcher.dispatch({
            type: Actions.SET_INSTANT_PRICES,
            payload: { prices },
        })
    },

    setInstantBookingPrice(price) {
        Dispatcher.dispatch({
            type: Actions.SET_INSTANT_BOOKING_PRICE,
            payload: { price },
        })
    },

    setTimeIsSelected(value) {
        Dispatcher.dispatch({
            type: Actions.SET_TIME_IS_SELECTED,
            payload: { value },
        })
    },

    setInstantBookingHash(hash) {
        Dispatcher.dispatch({
            type: Actions.SET_INSTANT_BOOKING_HASH,
            payload: { hash },
        })
    },

    calculateInstantBookingPrice() {
        Dispatcher.dispatch({
            type: Actions.CALCULATE_INSTANT_BOOKING_PRICE,
        })
    },

    setInstantBookingServices(services) {
        Dispatcher.dispatch({
            type: Actions.SET_INSTANT_BOOKING_SERVICES,
            payload: { services },
        })
    },

    selectInstantBookingPartDay(partDay) {
        Dispatcher.dispatch({
            type: Actions.SELECT_INSTANT_BOOKING_PART_DAY,
            payload: { partDay },
        })
    },

    showInstantBookingByQueryParam() {
        Dispatcher.dispatch({
            type: Actions.SHOW_INSTANT_BOOKING_BY_QUERY_PARAM,
        })
    },

    hideInstantBookingByQueryParam() {
        Dispatcher.dispatch({
            type: Actions.HIDE_INSTANT_BOOKING_BY_QUERY_PARAM,
        })
    },

    setInstantPriceDistance(distance) {
        Dispatcher.dispatch({
            type: Actions.SET_INSTANT_PRICE_DISTANCE,
            payload: { distance },
        })
    },

    setInstantGoogleMapsRoute(route) {
        Dispatcher.dispatch({
            type: Actions.SET_INSTANT_GOOGLE_MAPS_ROUTE,
            payload: { route },
        })
    },

    blockInstantBookingSpinner() {
        Dispatcher.dispatch({
            type: Actions.BLOCK_INSTANT_BOOKING_SPINNER,
        })
    },

    completeInstantBookingEmail() {
        Dispatcher.dispatch({
            type: Actions.COMPLETE_INSTANT_BOOKING_EMAIL,
        })
    },

    instantBookingHashLogModeOn() {
        Dispatcher.dispatch({
            type: Actions.INSTANT_BOOKING_HASH_LOG_MODE_ON,
        })
    },

    showInstantBookingByNormalizedRoute(normalizedLocations) {
        Dispatcher.dispatch({
            type: Actions.SHOW_INSTANT_BOOKING_BY_NORMALIZED_ROUTE,
            payload: { normalizedLocations },
        })
    },

    dumpInstantBookingLoaders(value) {
        Dispatcher.dispatch({
            type: Actions.TOGGLE_INSTANT_BOOKING_LOADERS,
            payload: { value },
        })
    },

    setInstantBookingDebugData(data) {
        Dispatcher.dispatch({
            type: Actions.SET_INSTANT_BOOKING_DEBUG_DATA,
            payload: { data },
        })
    },

    hideInstantBookingGoToAuctionButton() {
        Dispatcher.dispatch({
            type: Actions.HIDE_INSTANT_BOOKING_GO_TO_AUCTION_BUTTON,
        })
    },

    showInstantBookingGoToAuctionButton() {
        Dispatcher.dispatch({
            type: Actions.SHOW_INSTANT_BOOKING_GO_TO_AUCTION_BUTTON,
        })
    },

    showInstantBookingAwayModal() {
        Dispatcher.dispatch({
            type: Actions.SHOW_INSTANT_BOOKING_AWAY_MODAL,
        })
    },

    hideInstantBookingAwayModal() {
        Dispatcher.dispatch({
            type: Actions.HIDE_INSTANT_BOOKING_AWAY_MODAL,
        })
    },

    setInstantBookingPromocode(promocode = '', amount = 0) {
        Dispatcher.dispatch({
            type: Actions.SET_INSTANT_BOOKING_PROMOCODE,
            payload: { promocode, amount },
        })
    },


    calibrateGoogleNormalizedLocations(normalizedLocations, leaveCalibrationFlag = false) {
        let dataForCalibration = []
        normalizedLocations[0][1] ? dataForCalibration.push(normalizedLocations[0][1]) : dataForCalibration.push({});
        normalizedLocations[0][2] ? dataForCalibration.push(normalizedLocations[0][2]) : dataForCalibration.push({});
        normalizedLocations[1][1] ? dataForCalibration.push(normalizedLocations[1][1]) : dataForCalibration.push({});
        normalizedLocations[1][2] ? dataForCalibration.push(normalizedLocations[1][2]) : dataForCalibration.push({});

        return Promise.all(dataForCalibration.map((rawData, key) => {

            if (Object.keys(rawData).length === 0) {
                return new Promise(resolve => resolve(false))
            }

            if (!rawData.need_calibration && rawData.coords && rawData.coords.length > 0) {
                return new Promise(resolve => resolve(false));
            }

            let countryName = 'Россия';
            let countryField = find(countriesConfig, { id: rawData.country });
            if (countryField)
                countryName = countryField.name;

            return getLocationFromGoogleByQuery(countryName + ', ' + rawData.text).then(
                async (done) => {
                    if (!done.results)
                        return rawData;

                    let resultItems = done.results;

                    if (resultItems[0]) {
                        let resultItem = resultItems[0];
                        let geocodedData = await transformGoogleGeocodedData(resultItem);

                        rawData.coords = [geocodedData.coords.lng, geocodedData.coords.lat];
                        rawData.city_full = geocodedData.formatted_address;
                        rawData.country = geocodedData.country;
                        rawData.country_name = geocodedData.country_name;
                        rawData.country_iso = geocodedData.country_iso;
                        rawData.region = geocodedData.region;
                        rawData.area = geocodedData.area;
                        rawData.city = geocodedData.city;
                        rawData.street = geocodedData.street;
                        rawData.home = geocodedData.street_number;
                        rawData.postal_code = geocodedData.postal_code;
                        rawData.need_calibration = false;
                        rawData.text = geocodedData.formatted_address;
                        return rawData;
                    }
                    else {
                        return false;
                    }
                },
                error => {
                    return false;
                },
            );

        }))
            .then(result => {
                if (result && result.length > 0) {
                    if (result[0] && result[0].city_full && result[0].coords) {
                        normalizedLocations[0][1] = result[0]
                        normalizedLocations[0][1].city = result[0].city
                        normalizedLocations[0][1].city_full = result[0].city_full
                        normalizedLocations[0][1].coords = result[0].coords

                        if (leaveCalibrationFlag) {
                            normalizedLocations[0][1].need_calibration = true
                        }
                    }

                    if (result[1] && result[1].city_full && result[1].coords) {
                        normalizedLocations[0][2] = result[1]
                        normalizedLocations[0][2].city = result[1].city
                        normalizedLocations[0][2].city_full = result[1].city_full
                        normalizedLocations[0][2].coords = result[1].coords

                        if (leaveCalibrationFlag) {
                            normalizedLocations[0][2].need_calibration = true
                        }
                    }

                    if (result[2] && result[2].city_full && result[2].coords) {
                        normalizedLocations[1][1] = result[2]
                        normalizedLocations[1][1].city = result[2].city
                        normalizedLocations[1][1].city_full = result[2].city_full
                        normalizedLocations[1][1].coords = result[2].coords

                        if (leaveCalibrationFlag) {
                            normalizedLocations[1][1].need_calibration = true
                        }
                    }

                    if (result[3] && result[3].city_full && result[3].coords) {
                        normalizedLocations[1][2] = result[3]
                        normalizedLocations[1][2].city = result[3].city
                        normalizedLocations[1][2].city_full = result[3].city_full
                        normalizedLocations[1][2].coords = result[3].coords

                        if (leaveCalibrationFlag) {
                            normalizedLocations[1][2].need_calibration = true
                        }
                    }
                }

                return normalizedLocations
            })
            .catch(() => {
                return false
            })
    },


    calibrateNormalizedLocations(normalizedLocations, leaveCalibrationFlag = false) {

        if (process.env.NODE_ENV !== 'production') {
            // return new Promise(resolve => resolve(normalizedLocations))
        }

        let dataForCalibration = []

        if (normalizedLocations[0][1]) {
            dataForCalibration.push(normalizedLocations[0][1])
        } else {
            dataForCalibration.push({})
        }

        if (normalizedLocations[0][2]) {
            dataForCalibration.push(normalizedLocations[0][2])
        } else {
            dataForCalibration.push({})
        }

        if (normalizedLocations[1][1]) {
            dataForCalibration.push(normalizedLocations[1][1])
        } else {
            dataForCalibration.push({})
        }

        if (normalizedLocations[1][2]) {
            dataForCalibration.push(normalizedLocations[1][2])
        } else {
            dataForCalibration.push({})
        }

        //console.log('Калибровка');

        return Promise.all(dataForCalibration.map((rawData, key) => {

            if (Object.keys(rawData).length === 0) {
                return new Promise(resolve => resolve(false))
            }

            if (!rawData.need_calibration && rawData.coords && rawData.coords.length > 0) {
                return new Promise(resolve => resolve(false));
            }

            return dadataAddressCalibration(rawData.text, rawData.country)
                .then(responseData => {
                    if (responseData && responseData.response) {
                        return responseData.response
                    }

                    return false
                }).then(calibratedLocation => calibratedLocation)
        }))
            .then(result => {
                if (result && result.length > 0) {
                    if (result[0] && result[0].city_full && result[0].coords) {
                        normalizedLocations[0][1] = result[0]
                        normalizedLocations[0][1].city = result[0].city
                        normalizedLocations[0][1].city_full = result[0].city_full
                        normalizedLocations[0][1].coords = result[0].coords

                        if (leaveCalibrationFlag) {
                            normalizedLocations[0][1].need_calibration = true
                        }
                    }

                    if (result[1] && result[1].city_full && result[1].coords) {
                        normalizedLocations[0][2] = result[1]
                        normalizedLocations[0][2].city = result[1].city
                        normalizedLocations[0][2].city_full = result[1].city_full
                        normalizedLocations[0][2].coords = result[1].coords

                        if (leaveCalibrationFlag) {
                            normalizedLocations[0][2].need_calibration = true
                        }
                    }

                    if (result[2] && result[2].city_full && result[2].coords) {
                        normalizedLocations[1][1] = result[2]
                        normalizedLocations[1][1].city = result[2].city
                        normalizedLocations[1][1].city_full = result[2].city_full
                        normalizedLocations[1][1].coords = result[2].coords

                        if (leaveCalibrationFlag) {
                            normalizedLocations[1][1].need_calibration = true
                        }
                    }

                    if (result[3] && result[3].city_full && result[3].coords) {
                        normalizedLocations[1][2] = result[3]
                        normalizedLocations[1][2].city = result[3].city
                        normalizedLocations[1][2].city_full = result[3].city_full
                        normalizedLocations[1][2].coords = result[3].coords

                        if (leaveCalibrationFlag) {
                            normalizedLocations[1][2].need_calibration = true
                        }
                    }
                }

                return normalizedLocations
            })
            .catch(() => {
                return false
            })
    },

    setInstantBookingLoadersSaved(value) {
        Dispatcher.dispatch({
            type: Actions.SET_INSTANT_BOOKING_LOADERS_SAVED,
            payload: { value },
        })
    },

    setLoadersExpanded(value) {
        Dispatcher.dispatch({
            type: Actions.SET_LOADERS_EXPANDED,
            payload: { value },
        })
    },
};

export default ActionCreators;



// WEBPACK FOOTER //
// ./client/actions/ActionCreators.js